export const ko = {
  'ad.label': '광고',
  'ad.sponsored_by': '{advertiser} 제공',
  'ad.visit': '방문',
  'cookies.preferences': '쿠키 환경설정',
  'cookies.title': '당신의 개인정보는 당신이 관리합니다',
  'cookies.description': 'Albambam 작동에 필요한 저장소만 사용합니다. 분석이나 마케팅은 귀하의 허락이 있을 때만 활성화합니다. 언제든지 철회할 수 있습니다. 자세한 내용은',
  'cookies.privacy_link': '개인정보 처리방침',
  'cookies.close': '환경설정 닫기',
  'cookies.necessary': '필수',
  'cookies.necessary_desc': '세션, 보안, 언어 및 기본 환경설정.',
  'cookies.analytics': '분석',
  'cookies.analytics_desc': '서비스 개선을 위한 익명 사용 측정.',
  'cookies.marketing': '마케팅',
  'cookies.marketing_desc': '광고 개인화 및 캠페인 측정.',
  'cookies.configure': '설정',
  'cookies.reject': '선택 항목 거부',
  'cookies.save': '선택 저장',
  'cookies.accept': '모두 수락',
  'lang.selector_label': '언어',
  'lang.changed': '언어가 변경되었습니다',
  'nav.home': '홈',
  'nav.categories': '카테고리',
  'nav.shorts': '쇼츠',
  'nav.friends': '친구',
  'nav.upload': '업로드',
  'nav.profile': '프로필',
  'nav.login': '로그인',
  'common.signed_in': '로그인되었습니다',
  'common.error': '오류',
  'topbar.search_placeholder': '동영상, 크리에이터 검색...',
  'legal.terms': '약관',
  'legal.privacy': '개인정보',
  'nav.admin': '관리',
  'nav.logout': '로그아웃',
  'admin.tab.payments': '결제',
  'admin.payments.title': '결제',
  'cats.title': '카테고리',
  'cats.all': '전체',
  'cats.adult_title': '18+ 카테고리',
  'cats.empty': '이 카테고리에 동영상이 없습니다.',
  'friends.block_confirm': '이 친구를 차단할까요? 더 이상 채팅하거나 친구로 볼 수 없습니다.',
  'friends.accepted': '이제 친구입니다!',
  'friends.title': '친구',
  'friends.subtitle': '서로 팔로우한 사람만 친구가 되어 비공개 채팅을 할 수 있습니다.',
  'friends.unread_count_label': '읽지 않은 메시지 {n}개',
  'friends.blocked_users_title': '차단한 사용자',
  'friends.unblock_user': '차단 해제',
  'friends.requests_title': '채팅 요청',
  'friends.request_badge': '요청',
  'friends.request_accept': '수락',
  'friends.request_ignore': '무시',
  'friends.empty_title': '아직 친구가 없습니다',
  'friends.empty_subtitle': '누군가를 팔로우하고 맞팔로우되면 비공개 채팅이 열립니다.',
  'friends.attach_image': '사진',
  'friends.shared_video_label': '동영상을 공유했습니다',
  'friends.select_conversation': '채팅을 시작할 친구를 선택하세요',
  'friends.block_user': '차단',
  'friends.no_messages_yet': '아직 메시지가 없습니다. 인사해 보세요!',
  'friends.message_placeholder': '메시지를 작성하세요...',
  'section.trending': '인기',
  'section.shorts': '쇼츠',
  'section.for_you': '추천',
  'home.hero.badge': 'Albambam에 오신 것을 환영합니다',
  'home.hero.title_1': '짧은 동영상.',
  'home.hero.title_2': '진짜 크리에이터.',
  'home.hero.subtitle': '보고, 공유하고, 수익을 올리세요. 동영상을 업로드하고 모든 카테고리에서 새로운 재능을 발견하세요.',
  'home.hero.cta_shorts': '쇼츠 보기',
  'home.hero.cta_trending': '인기',
  'home.shorts.see_all': '모두 보기',
  'home.empty.title': '아직 동영상이 없습니다',
  'home.empty.subtitle': '크리에이터가 콘텐츠를 올리면 여기에 표시됩니다.',
  'live.send_diamonds': '다이아몬드 보내기',
  'live.buy': '구매',
  'live.chat': '채팅',
  'live.type_message': '메시지를 작성하세요...',
  'live.send': '보내기',
  'auth.success_google': 'Google로 로그인되었습니다',
  'auth.fail_google': '유효하지 않은 Google 세션',
  'auth.success_login': '로그인되었습니다',
  'auth.success_register': '계정이 생성되었습니다',
  'auth.login_tab': '로그인',
  'auth.register_tab': '회원가입',
  'auth.email': '이메일',
  'auth.password': '비밀번호',
  'auth.submit_login_loading': '로그인 중...',
  'auth.submit_login': '로그인',
  'auth.name': '이름',
  'auth.submit_register_loading': '생성 중...',
  'auth.submit_register': '회원가입',
  'auth.or': '또는',
  'legal.privacy_title': '개인정보 처리방침',
  'search.title': '"{q}" 검색 결과',
  'search.count': '동영상 {n}개',
  'search.empty': '결과가 없습니다.',
  'series.load_error': '시리즈를 불러올 수 없습니다',
  'series.unlocked': '시리즈가 잠금 해제되었습니다',
  'series.purchase_error': '구매를 시작할 수 없습니다',
  'series.restricted': '접근 제한',
  'series.configure_access': '접근 설정',
  'series.language_all': '모든 언어',
  'series.episode_count': '{n}개 에피소드',
  'series.buy': '시리즈 구매',
  'series.filter_language': '언어별 필터',
  'series.no_episodes': '아직 공개된 에피소드가 없습니다.',
  'series.episode_number': '에피소드 {n}',
  'legal.terms_title': '이용약관',
  'lang.ca': '카탈로니아어',
  'lang.en': '영어',
  'lang.es': '스페인어',
  'lang.fr': '프랑스어',
  'lang.de': '독일어',
  'lang.it': '이탈리아어',
  'lang.eu': '바스크어',
  'lang.gl': '갈리시아어',
  'lang.zh': '중국어',
  'lang.other': '기타',
  'lang.vi': '베트남어',
  'lang.ja': '일본어',
  'lang.ko': '한국어',
  'lang.ru': '러시아어',
  'lang.ro': '루마니아어',
  'lang.ar': '아랍어',
  'lang.tr': '터키어',
  'lang.pl': '폴란드어',
  'lang.ms': '말레이어',
  'lang.ta': '타밀어',
  'upload.series_title_error': '시리즈 제목을 입력하세요',
  'upload.series_adult_category_error': '시리즈의 18+ 카테고리를 선택하세요',
  'upload.series_created': '시리즈가 생성되었습니다',
  'upload.series_create_error': '시리즈를 생성할 수 없습니다',
  'upload.err_file': '유효한 동영상 파일을 선택하세요',
  'upload.err_title': '제목을 입력하세요',
  'upload.series_select_error': '시리즈를 선택하거나 생성하세요',
  'upload.trailer_target_error': '트레일러의 동영상 또는 시리즈를 선택하세요',
  'upload.price_error': '최소 0.50 EUR의 유효한 가격을 입력하세요.',
  'upload.adult_category_error': '성인 카테고리를 선택하세요',
  'upload.success': '동영상이 업로드되었습니다',
  'upload.title_h': '동영상 업로드',
  'upload.kind': '게시 유형',
  'upload.kind_video': '단독 동영상',
  'upload.kind_episode': '시리즈 에피소드',
  'upload.kind_trailer': '쇼츠의 공개 트레일러',
  'upload.series': '시리즈',
  'upload.series_select': '시리즈 선택',
  'upload.episode': '에피소드',
  'upload.series_new_title': '새 시리즈 제목',
  'upload.series_create': '시리즈 생성',
  'upload.series_adult': '18+ 시리즈',
  'upload.series_premium': '프리미엄 시리즈',
  'upload.series_adult_category': '시리즈 18+ 카테고리',
  'upload.series_price': '에피소드 및 패키지 가격 (EUR)',
  'upload.trailer_for': '트레일러 소개 대상',
  'upload.trailer_select': '동영상 또는 시리즈 선택',
  'upload.video_prefix': '동영상',
  'upload.file_label': '동영상 파일 (MP4, 최대 1GB)',
  'upload.file_pick': '클릭하여 동영상 선택',
  'upload.thumb_label': '썸네일 (선택)',
  'upload.video_title': '제목',
  'upload.description': '설명',
  'upload.category': '카테고리',
  'upload.is_short': '쇼츠입니다 (세로)',
  'upload.paid_video': '유료 동영상',
  'upload.adult_content': '18+ 콘텐츠',
  'upload.video_language': '동영상 언어',
  'upload.individual_price': '이 동영상 시청 가격 (EUR)',
  'upload.paid_video_help': '시청자는 이 동영상에 대한 영구 접근권만 구매합니다. 최저 가격은 0.50 EUR입니다.',
  'upload.adult_category': '성인 카테고리',
  'upload.uploading': '업로드 중 {n}%',
  'upload.submit': '동영상 업로드',
  'user.followers': '팔로워',
  'user.following': '팔로잉',
  'user.follow': '팔로우',
  'user.chat_open': '채팅',
  'user.request_sent': '요청을 보냈습니다',
  'user.send_message': '메시지 보내기',
  'user.followers_title': '팔로워',
  'user.following_title': '팔로잉',
  'user.unfollow': '언팔로우',
  'user.request_title': '채팅 요청',
  'user.request_subtitle': '메시지는 하나만 보낼 수 있습니다. 상대가 요청을 수락하면 친구가 되어 채팅할 수 있습니다.',
  'user.request_placeholder': '메시지를 작성하세요...',
  'user.request_send': '요청 보내기',
  'shorts.login_for_like': '좋아요하려면 로그인',
  'watch.share_copied': '링크가 복사되었습니다',
  'watch.delete_confirm': '이 댓글을 삭제할까요?',
  'ad.skip_in': '{n}초 후 건너뛰기',
  'ad.skip': '광고 건너뛰기',
  'watch.share': '공유',
  'friends.share_video': '동영상 공유',
  'friends.send': '보내기',
  'watch.comments': '댓글',
  'watch.write_comment': '댓글을 작성하세요...',
  'watch.publish': '게시',
  'watch.login_to_comment': '댓글을 쓰려면 로그인하세요.',
  'watch.login_btn': '로그인하여 댓글 작성',
  'watch.no_comments': '아직 댓글이 없습니다.',
  'watch.related': '관련 동영상',
  'nav.trending': '인기',
  'friends.follow_option_only_follow': '팔로우',
  'friends.follow_option_friends': '친구',
  'watch.like': '좋아요',
  'watch.views_short': '조회수 {n}회',
  'shorts.empty.title': '아직 쇼츠가 없습니다',
  'shorts.empty.subtitle': '짧은 동영상을 업로드하여 섹션을 시작하세요.',
  'shorts.share': '공유',
  'auth.continue_google': 'Google로 계속',
  'upload.is_premium': '프리미엄',
  'upload.price': '가격 (€)',
  'upload.err_select': '동영상을 선택하세요',
  'profile.upload_btn': '동영상 업로드',
  'profile.tab_videos': '내 동영상 ({n})',
  'profile.tab_history': '시청 기록',
  'profile.tab_recos': '추천',
  'profile.no_videos': '아직 동영상을 업로드하지 않았습니다.',
  'profile.no_history': '아직 동영상을 시청하지 않았습니다.',
  'profile.no_recos': '추천을 받으려면 동영상을 시청하세요.',
  'profile.likes': '좋아요',
  'profile.views': '조회수',
  'wallet.title': '지갑',
  'wallet.rate_label': '요율',
  'wallet.min_label': '최소 출금액',
  'wallet.amount_label': '출금 금액',
  'wallet.withdraw_btn': '출금 요청',
  'wallet.history_title': '요청 내역',
  'wallet.success': '요청이 생성되었습니다',
  'wallet.bad_amount': '유효하지 않은 금액',
  'wallet.per_view': '{rate} {cur}/조회',
  'admin.title': '관리',
  'admin.stats.users': '사용자',
  'admin.stats.videos': '동영상',
  'admin.stats.shorts': '쇼츠',
  'admin.stats.views': '조회수',
  'admin.tab.videos': '동영상',
  'admin.tab.ads': '광고',
  'admin.tab.users': '사용자',
  'admin.tab.withdrawals': '출금',
  'admin.tab.config': '설정',
  'admin.tab.translations': '언어',
  'tbl.title': '제목',
  'tbl.creator': '크리에이터',
  'tbl.category': '카테고리',
  'tbl.type': '유형',
  'tbl.views': '조회수',
  'tbl.likes': '좋아요',
  'tbl.status': '상태',
  'tbl.actions': '작업',
  'tbl.placement': '위치',
  'tbl.advertiser': '광고주',
  'tbl.impressions': '노출',
  'tbl.clicks': '클릭',
  'tbl.active': '활성',
  'tbl.name': '이름',
  'tbl.email': '이메일',
  'tbl.role': '역할',
  'tbl.wallet': '지갑',
  'tbl.amount': '금액',
  'tbl.date': '날짜',
  'tbl.user': '사용자',
  'video.video': '동영상',
  'video.short': '쇼츠',
  'action.show': '게시',
  'action.hide': '숨김',
  'action.delete_confirm_video': '동영상을 삭제할까요?',
  'ad.create_h': '광고 생성',
  'ad.title_label': '제목',
  'ad.image_label': '이미지 URL',
  'ad.target_label': '대상 URL',
  'ad.advertiser_label': '광고주',
  'ad.placement_label': '배치',
  'ad.placement.banner': '배너 (웹사이트)',
  'ad.placement.preroll': '프리롤 (동영상 전)',
  'ad.placement.overlay': '오버레이 (동영상 내)',
  'ad.active': '활성',
  'ad.create_btn': '생성',
  'ad.success_create': '광고가 생성되었습니다',
  'ad.delete_confirm': '광고를 삭제할까요?',
  'users.make_admin': '관리자로 지정',
  'users.remove_admin': '관리자 해제',
  'wd.approve': '승인',
  'wd.reject': '거부',
  'wd.mark_paid': '지불 완료 표시',
  'wd.empty': '요청 없음',
  'cfg.title': '결제 설정',
  'cfg.rate_label': '조회당 지급 ({cur})',
  'cfg.min_label': '출금 최소액 ({cur})',
  'cfg.currency': '통화',
  'cfg.save': '저장',
  'cfg.saved': '설정이 저장되었습니다',
  'trans.title': '언어 및 번역',
  'trans.intro': '임의의 언어 코드(예: ja, pt, zh)에 대한 번역이 담긴 JSON 파일을 업로드하세요. 파일은 키 → 텍스트의 플랫 맵이어야 합니다.',
  'trans.code_label': '언어 코드 (예: ja, pt-BR, zh)',
  'trans.name_label': '표시 이름 (해당 언어로)',
  'trans.file_label': '번역 JSON 파일',
  'trans.upload': '업로드',
  'trans.uploaded': '번역이 저장되었습니다',
  'trans.delete': '삭제',
  'trans.delete_confirm': '이 언어를 삭제할까요?',
  'trans.builtin': '내장',
  'trans.custom': '사용자 지정',
  'trans.empty_custom': '아직 사용자 지정 언어가 없습니다.',
  'common.cancel': '취소',
  'common.loading': '로딩 중...',
  'common.too_fast': '너무 빠릅니다. 잠시 기다려 주세요',
  'time.few_seconds': '몇 초 전',
  'time.min': '{n}분 전',
  'time.h': '{n}시간 전',
  'time.d': '{n}일 전',
  'time.w': '{n}주 전',
  'time.mo': '{n}개월 전',
  'time.y': '{n}년 전',
  'brand.tagline': '짧은 동영상. 진짜 크리에이터.',
  'live.section': '라이브',
  'live.start': '라이브 시작',
  'live.end': '라이브 종료',
  'live.join': '라이브 참여',
  'live.chat_placeholder': '메시지를 작성하세요...',
  'live.diamond': '다이아몬드',
  'live.buy_access': '이용권 구매',
  'live.save_recording': '녹화 저장',
};
